import { OrderType } from './../../enums/order-type.enum';
import { DictionaryValue } from './../dictionary/dictionaryValue';
import { BaseClass } from '../base-class';
import { Client } from '../client';
import { User } from '../user/user';
import { OrderStatus } from '@enums/order-status.enum';
import { Site } from '@classes/site';
import { RecurringOrderStep } from './recurringOrderStep';

export class RecurringOrder extends BaseClass {
  identifier: string;
  site: Site;
  urgency: DictionaryValue;
  dispatcherComment: string;
  sender: RecurringOrderStep;
  receivers: RecurringOrderStep[];
  ordererComment?: string;
  ordererPhone?: string;
  ordererName: string;
  status: OrderStatus;
  type: OrderType;
  cronExpression: string;
  cronDescription: string;
  minutesToAdd: number;
  price: number;
  extraStepPrice: number;
  driver: User;
  scheduledDate?: Date;
  orderStartDate?: Date;

  isDeleted?: boolean;
  startTime?: string;

  transportTypes: DictionaryValue[];

  client?: Client;

  modifiedFields?: string[];

  tagScanned: string;
  arrivedOn?: Date;
  completedOn?: Date;
  scansPickedGroupedByContainer?: any = {};
  scansDeliveredGroupedByContainer?: any = {};

  isVerySoon?: boolean;
  name: string;
  code?: string;

  isActive: boolean;
  isActiveOnHolidays: boolean;

  constructor();
  constructor(
    site: Site,
    urgency: DictionaryValue,
    ordererPhone: string,
    ordererName: string,
    sender: RecurringOrderStep,
    receivers: RecurringOrderStep[],
    transportTypes: DictionaryValue[],
    cronExpression: string,
    minutesToAdd: number,
    type: OrderType,
    ordererComment?: string,
  );
  constructor(
    site?: Site,
    urgency?: DictionaryValue,
    ordererPhone?: string,
    ordererName?: string,
    sender?: RecurringOrderStep,
    receivers?: RecurringOrderStep[],
    transportTypes?: DictionaryValue[],
    cronExpression?: string,
    minutesToAdd?: number,
    type?: OrderType,
    ordererComment?: string,
  ) {
    super();

    this.site = site;
    this.urgency = urgency;
    this.ordererPhone = this.trim(ordererPhone);
    this.ordererName = this.trim(ordererName);
    this.sender = sender;
    this.receivers = receivers;
    this.ordererComment = this.trim(ordererComment);
    this.transportTypes = transportTypes;
    this.cronExpression = cronExpression;
    this.type = type;
    this.minutesToAdd = minutesToAdd;
  }

  static fromObject(object: RecurringOrder): RecurringOrder {
    return Object.assign(new RecurringOrder(), {
      ...object,
      driver: object.driver ? User.fromObject(object.driver) : null,
      site: object.site ? Site.fromObject(object.site) : null,
      urgency: object.urgency
        ? DictionaryValue.fromObject(object.urgency)
        : null,
      // sender: object.sender ? Address.fromObject(object.sender) : null
      client: object.client ? Client.fromObject(object.client) : null,
    });
  }

  get display(): string {
    return this.identifier;
  }
}
